<a class="btn" [ngClass]="color" [attr.data-video-title]="title" [attr.href]="href" [routerLink]="link"  title="{{ title }}">
  Watch <i class="fa fa-play" aria-hidden="true"></i>
</a>